var map = {
	"./bs.json": 1063,
	"./da.json": 1064,
	"./de.json": 1065,
	"./en-US.json": 1066,
	"./es.json": 1067,
	"./fi.json": 1068,
	"./fr.json": 1069,
	"./hu.json": 1070,
	"./it.json": 1071,
	"./ja.json": 1072,
	"./nl.json": 1073,
	"./pt.json": 1074,
	"./tr.json": 1075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 420;